import enUS from '../../locales/en_US.json';
import csCZ from '../../locales/cs_CZ.json';
import daDK from '../../locales/da_DK.json';
import deDE from '../../locales/de_DE.json';
import elGR from '../../locales/el_GR.json';
import esES from '../../locales/es_ES.json';
import esMX from '../../locales/es_MX.json';
import esPR from '../../locales/es_PR.json';
import fiFI from '../../locales/fi_FI.json';
import frCA from '../../locales/fr_CA.json';
import frFR from '../../locales/fr_FR.json';
import heIL from '../../locales/he_IL.json';
import hrHR from '../../locales/hr_HR.json';
import huHU from '../../locales/hu_HU.json';
import isIS from '../../locales/is_IS.json';
import itIT from '../../locales/it_IT.json';
import jaJP from '../../locales/ja_JP.json';
import koKR from '../../locales/ko_KR.json';
import nlNL from '../../locales/nl_NL.json';
import noNO from '../../locales/no_NO.json';
import plPL from '../../locales/pl_PL.json';
import ptPT from '../../locales/pt_PT.json';
import roRO from '../../locales/ro_RO.json';
import slSI from '../../locales/sl_SI.json';
import svSE from '../../locales/sv_SE.json';
import thTH from '../../locales/th_TH.json';
import trTR from '../../locales/tr_TR.json';
import zhCN from '../../locales/zh_CN.json';
import zhHK from '../../locales/zh_HK.json';
import zhTW from '../../locales/zh_TW.json';

const translationMappings = locale => {
  const defaultLocale = 'en_US';
  const translations = {
    en_US: enUS,
    cs_CZ: csCZ,
    da_DK: daDK,
    de_AT: deDE,
    de_CH: deDE,
    de_DE: deDE,
    de_LU: deDE,
    el_GR: elGR,
    es_ES: esES,
    es_MX: esMX,
    es_PR: esPR,
    fi_FI: fiFI,
    fr_BE: frFR,
    fr_CA: frCA,
    fr_CH: frFR,
    fr_FR: frFR,
    fr_LU: frFR,
    he_IL: heIL,
    hr_HR: hrHR,
    hu_HU: huHU,
    is_IS: isIS,
    it_CH: itIT,
    it_IT: itIT,
    ja_JP: jaJP,
    ko_KR: koKR,
    nl_BE: nlNL,
    nl_NL: nlNL,
    no_NO: noNO,
    pl_PL: plPL,
    pt_PT: ptPT,
    ro_RO: roRO,
    sl_SI: slSI,
    sv_SE: svSE,
    th_TH: thTH,
    tr_TR: trTR,
    zh_CN: zhCN,
    zh_HK: zhHK,
    zh_MO: zhHK,
    zh_TW: zhTW,
  };

  if (translations[locale]) {
    return translations[locale];
  }
  return translations[defaultLocale];
};

const getTranslationsByLocale = locale => translationMappings(locale);

export default getTranslationsByLocale;
